module.exports = __webpack_public_path__ + "img/ewm1.a830b33e.png";